<template>
    <!-- 菜单 -->
    <div class="header-nav_inner">
        <nav>
            <ul class="header-nav_list">
                <li class="header-nav_item" v-for="item in navlist" :key="item.id" @click="handleNav(item.id)">
                    <img :src="activeIndex == item.id ? item.activeUrl : item.url" />
                </li>
            </ul>
        </nav>
        <div class="logo"></div>
        <div class="pay-btn" @click="handlePayBth()">
            <div class="scale-f"></div>
        </div>
        <div class="lang_box">
            <div v-if="isPlay" class="close-music-icon icon-size music-on" @click="open_voice()"></div>
            <div v-else class="open-music-icon icon-size music-on" @click="close_voice()"></div>
        </div>
        <!-- 背景音乐 -->
        <audio controls="controls" loop ref="audio" id="nameAttrValue" style="display: none;">
            <source :src="musicUrl" type="audio/wav" />
        </audio>
    </div>
</template>
<script>

export default {
    data() {
        return {
            isPlay: false,
            // 音频文件路径
            musicUrl: require('../../assets/audio/bg_music.mp3'),
            navlist: [
                {
                    id: 1,
                    url: require('../../assets/img/nav/tab1-b.png'),
                    activeUrl: require('../../assets/img/nav/tab1-c.png'),
                },
                // {
                //     id: 2,
                //     url: require('../../assets/img/nav/tab2-b.png'),
                //     activeUrl: require('../../assets/img/nav/tab2-c.png'),
                // },
                {
                    id: 3,
                    url: require('../../assets/img/nav/tab3-b.png'),
                    activeUrl: require('../../assets/img/nav/tab3-c.png'),
                },
                {
                    id: 4,
                    url: require('../../assets/img/nav/tab4-b.png'),
                    activeUrl: require('../../assets/img/nav/tab4-c.png'),
                },
                {
                    id: 5,
                    url: require('../../assets/img/nav/tab5-b.png'),
                    activeUrl: require('../../assets/img/nav/tab5-c.png'),
                },
                {
                    id: 6,
                    url: require('../../assets/img/nav/tab6-b.png'),
                    activeUrl: require('../../assets/img/nav/tab6-c.png'),
                },
            ],
            activeIndex: 1,
        }
    },
    created() {

        // 获取上次点击的区域 
        this.activeIndex = 1
        let navtest = this.$route.query.view >= 1 ? this.$route.query.view : this.$route.query.view
        this.activeIndex = navtest || 1

    },
    methods: {
        handlePayBth() {
            // alert('決済機能は現在準備中です。今しばらくお待ち願います。')

            window.open(`https://aepay.ujoygames.com/`, '_blank');
        },

        handleNav(val) {
            this.activeIndex = val
            this.$emit('handleNavIndex', val)

        },

        // 音乐按钮控制
        open_voice() {
            this.isPlay = false
            let audio = this.$refs.audio;
            audio.pause();

        },
        close_voice() {
            this.isPlay = true
            let audio = this.$refs.audio;
            audio.play();


        },

    }
}
</script>
<style lang="scss">
.header-nav_inner {

    .header-nav_list {
        height: 80px;
        // background: url('../../assets/img/nav/nav-bg.png');
        background: #00000023;
        position: relative;
        display: flex;
        align-items: center;
        // justify-content: center;
        position: absolute;
        top: 0;
        padding-left: 15vw;
        z-index: 2;
        width: 100%;

        .header-nav_item {
            width: 251px;
            height: 80px;
            cursor: pointer;
            transition: all .3s;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }
    }

    .logo {
        width: 181px;
        height: 58px;
        background: url('../../assets/img/nav/logo.png');
        position: absolute;
        left: 41px;
        top: 16px;
        z-index: 2;
        background-size: 100% 100%;
    }

    .pay-btn {
        width: 242px;
        height: 80px;
        background: url('../../assets/img/nav/pay-btn.png');
        position: absolute;
        right: 7vw;
        z-index: 2;
        background-size: 100% 100%;
        top: 0;
        cursor: pointer;
        display: flex;
        align-items: start;
        justify-content: center;

        .scale-f {
            width: 148px;
            height: 24px;
            background: url('../../assets/img/nav/bn.png');
            background-size: 100% 100%;
            margin-top: 4px;
        }

        &:hover {
            background: url('../../assets/img/nav/pay-btn-active.png');
            background-size: 100% 100%;

        }
    }

    .lang_box {

        position: absolute;
        right: 51px;
        top: 16px;
        z-index: 2;

        .close-music-icon {

            background: url('../../assets/img/nav/on.png');
            background-size: 100% 100%;
        }

        .open-music-icon {
            background: url('../../assets/img/nav/off.png');
            background-size: 100% 100%;
            animation-play-state: paused !important;

        }

        .icon-size {
            width: 51px;
            height: 51px;
            cursor: pointer;
        }

        .music-on {
            animation: playAni 5s linear infinite;
        }

        .animated {

            animation-duration: .1s;
            animation-fill-mode: both
        }

        .animated.infinite {
            -webkit-animation-iteration-count: infinite;
            animation-iteration-count: infinite
        }

    }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/headerNav.vue